import { useEffect, useState } from 'react';
import { Circles } from 'react-loader-spinner';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './style/index.css';
import NavBar from './components/NavBar';
import SideBar from './components/SideBar';
import Login from './pages/Login';
import Landing from './pages/Landing';
import Ordenes from './pages/Orders';
import Personal from './pages/Employee';
import Proveedor from './pages/Customer';
import Workshops from './pages/Workshops';
import Logout from './pages/Logout';
import AuthenticatedLogin from './utils/AuthenticatedLogin';
import { UserProvider } from './utils/UserContext';
import Clients from './pages/Clients';
import GoogleCallback from './pages/GoogleCallback';

function App() {
  const [isLogin, setIsLogin] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);       // Estado para manejar la carga inicial

  // 
  useEffect(() => {
    const login = localStorage.getItem('isLogin');
    const expiry = localStorage.getItem('sessionExpiry');
    if (login === 'true' && expiry && Date.now() < Number(expiry)) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
      localStorage.removeItem('isLogin');
      localStorage.removeItem('sessionExpiry');
      localStorage.removeItem('user');
      localStorage.removeItem('workshops');
      localStorage.removeItem('selectedWorkshop');
      localStorage.removeItem('user_id');
      localStorage.removeItem('authToken');
    }
    setLoading(false);                          // Marcar como cargado una vez que se verifica el estado de inicio de sesión
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="App">
      <UserProvider>
        <Router>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <Circles
                height="80"
                width="80"
                color="#1976d2"
                ariaLabel="loading-indicator"
                visible={true}
              />
            </div>
          ) : (
            <Routes>
              <Route path="/login" element={<Login setIsLogin={setIsLogin} />} />
              <Route path="/auth/callback" element={<GoogleCallback setIsLogin={setIsLogin} />} />
              <Route path="/logout" element={<Logout setIsLogin={setIsLogin}/>} />
              <Route path="/" element={<Landing />} />
              <Route
                path="/*"
                element={
                  <AuthenticatedLogin isAuthenticated={isLogin} loading={loading}>
                    <div className={`app-layout ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
                      <div
                        className={`sidebar-backdrop ${isSidebarOpen ? 'visible' : ''}`}
                        onClick={toggleSidebar}
                        aria-hidden="true"
                      />
                      <SideBar
                        isSidebarOpen={isSidebarOpen}
                        toggleSidebar={toggleSidebar}
                      />


                      <div className="main-layout">
                        <NavBar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                        <Routes>
                          <Route path="/talleres" element={<Workshops />} />
                          <Route path="/ordenes" element={<Ordenes />} />
                          <Route path="/clientes" element={<Clients />} />
                          <Route path="/personal" element={<Personal />} />
                          <Route path="/proveedor" element={<Proveedor />} />
                        </Routes>
                      </div>
                    </div>
                  </AuthenticatedLogin>
                }
              />
            </Routes>
          )}
        </Router>
        <ToastContainer />
      </UserProvider>
    </div>
  );
}

export default App;
